import React from 'react';
import { MainLayout } from '../../components/layout';
import UserList from './UserList';

const UserManagement: React.FC = () => {
  return (
    <MainLayout>
      <UserList />
    </MainLayout>
  );
};

export default UserManagement;
